import { Text } from 'designSystem/components/Text'
import {
  AgenticSearchBox,
  type AgenticSearchBoxProps,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticSearchBox'
import type { AgenticConversationTurn } from 'features/knowledgeDocumentViewer/types'
import React from 'react'
import styled from 'styled-components'

import { AgenticSearchTimeline } from './AgenticSearchTimeline'

type AgenticSearchResultsHeaderVariant = 'header' | 'sidePanel'

const HeaderRoot = styled.div<{ $variant: AgenticSearchResultsHeaderVariant }>`
  position: relative;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  flex-shrink: 0;
  ${(props) =>
    props.$variant === 'header'
      ? `
        background: var(--sidebar);
        border-bottom: 0.0625rem solid var(--border);
      `
      : `
        background: var(--card);
        width: 100%;
        height: 100%;
        min-height: 0;
        min-width: 0;
        padding: 0.5rem 0 0.5rem 0.5rem;
        border-right: 0.0625rem solid var(--border);
      `}
`

const InputRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  width: 100%;
  padding-right: 0.5rem;
  flex-shrink: 0;
`

interface AgenticSearchResultsHeaderProps extends Omit<
  AgenticSearchBoxProps,
  'placeholder' | 'rightContent' | 'variant'
> {
  turns: AgenticConversationTurn[]
  viewModeControl?: React.ReactNode
  variant?: AgenticSearchResultsHeaderVariant
}

export function AgenticSearchResultsHeader({
  turns,
  viewModeControl,
  variant = 'header',
  ...searchBoxProps
}: AgenticSearchResultsHeaderProps): React.ReactElement {
  return (
    <HeaderRoot $variant={variant}>
      <AgenticSearchTimeline turns={turns} variant={variant} />
      <InputRow>
        <AgenticSearchBox
          {...searchBoxProps}
          placeholder={
            variant === 'sidePanel'
              ? 'Ask a follow up question...'
              : 'Ask a follow up'
          }
          rightContent={viewModeControl}
          surface={variant === 'sidePanel' ? 'plain' : 'default'}
          variant='compact'
        />
        {variant === 'sidePanel' ? (
          <Text as='p' variant='caption' color='muted' align='center'>
            Cantilever can make mistakes. Double-check responses.
          </Text>
        ) : null}
      </InputRow>
    </HeaderRoot>
  )
}
